import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApeDrawerComponent } from "../ape-drawer/ape-drawer.component";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { LoggerService } from "../../../ancestors/logger.service";
import { SvgIconComponent } from "angular-svg-icon";
import { UserDataService } from "src/app/services/data/user-data.service";

/**
 * Componente sidenav per la sezione supporto
 * Mostra contatti email e materiali informativi per l'utente
 */
@Component({
  selector: "ape-support-sidenav",
  standalone: true,
  imports: [
    CommonModule,
    ApeDrawerComponent,
    TranslatePipe,
    SvgIconComponent
  ],
  templateUrl: "./ape-support-sidenav.component.html"
})
export class ApeSupportSidenavComponent {
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private logger = inject(LoggerService);

  private userDataService = inject(UserDataService);

  /**
   * Visibilità del drawer
   */
  @Input() visible = false;

  /**
   * Evento di cambio visibilità
   */
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  /**
   * Gestisce il cambio di visibilità del drawer
   */
  onVisibleChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
  }

  /**
   * Verifica se l'utente corrente è un Manager
   */
  get isManager(): boolean {
    return this.userDataService?.isManager() ?? false;
  }

  /**
   * Restituisce l'array di link materiali per il template
   */
  get materialLinksSection1(): {
    label: string;
    url: string;
  }[] {
    return [
      {
        label: this.TRANSLATION_KEYS.support.MATERIAL_SECTION_LINK1_LABEL,
        url: this.TRANSLATION_KEYS.support.MATERIAL_SECTION_LINK1_URL
      }
    ];
  }

  get materialLinksSection2(): {
    label: string;
    url: string;
  }[] {
    return [
      {
        label: this.TRANSLATION_KEYS.support.MATERIAL_SECTION_LINK2_LABEL,
        url: this.TRANSLATION_KEYS.support.MATERIAL_SECTION_LINK2_URL
      }
    ];
  }

  /**
   * TrackBy per i link
   */
  trackByLinkUrl(index: number, link: {
    label: string;
    url: string;
  }): string {
    return link.url;
  }
}
